/**
 * Central TanStack query-key factory for the gen-3 cohort detail page.
 * Keep keys nested under a single root so a `cohortDetailKeys.all` invalidation
 * blows away every gen-3 read for a cohort in one shot.
 */
export const cohortDetailKeys = {
  all: ['gen-3', 'cohort-detail'] as const,
  version: (cohortVersionId: string) =>
    [...cohortDetailKeys.all, 'version', cohortVersionId] as const,
  conceptGroups: (projectId: string) =>
    [...cohortDetailKeys.all, 'concept-groups', projectId] as const,
  attrition: (cohortVersionId: string) =>
    [...cohortDetailKeys.all, 'attrition', cohortVersionId] as const,
  characteristics: (cohortVersionId: string) =>
    [...cohortDetailKeys.all, 'characteristics', cohortVersionId] as const,
  subjects: (cohortVersionId: string) =>
    [...cohortDetailKeys.all, 'subjects', cohortVersionId] as const,
};
